






import { Vue, Component } from 'vue-property-decorator';
import ListItem from '@/components/ListItem/index.vue';
@Component({
  components: {
    ListItem,
  },
})
export default class ListPage extends Vue {}
